import ErrorMessagesJson from './error_messages.json';
export const ErrorMessages = ErrorMessagesJson;
